import PropTypes from 'prop-types';

const { LP } = window;

const FacetCheckboxesShowMoreButton = ({ facet, context }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    if (facet.disabled) return;

    context.executeAction(LP.module('Searches').SearchActions.toggleFacetExpand, {
      facet
    });
  };

  return (
    <span className="show-more-facets flex items-center mt-0" onClick={handleClick}>
      <i className="lp-icon-arrow fa-regular fa-angle-right" />
    </span>
  );
};

FacetCheckboxesShowMoreButton.propTypes = {
  facet: PropTypes.object,
  context: PropTypes.object
};

export default FacetCheckboxesShowMoreButton;
